import { rootStore } from "../StApp"

const UserText = (props: { text: string, unread?: boolean }) => {

    return (
        <div className='flex-row' >
            <p className='text-chat-overview' style={{ fontWeight: props.unread ? 'bolder' : 'normal' }} >{props.text}</p>
        </div>
    )
}

export default UserText